
<template>

    <v-app>
    <v-main>
    <v-container
        fluid
    >
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-card
                    class="mx-auto mt-16"
                    max-width="600"
                    outlined
                >
                    <FormLogin></FormLogin>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    </v-main>
    </v-app>
</template>

<script>
import FormLogin from '@/components/Login/FormLogin.vue'

export default {
  components: {
    FormLogin
  }
}
</script>